<template>
  <div class="categoreis-filters padding_large bg-gray">
    <ul v-if="filters && filters.length > 0" class="filter-list">
      <li>
        <button
          role="option"
          class="btn-filter btn"
          :class="{ active: !activeFilters.length }"
          @click="nullFilters"
          :aria-selected="activeFilters.length ? 'false' : 'true'"
        >
          Vis alle
        </button>
      </li>
      <li v-for="(filter, i) in filters" :key="i">
        <button
          role="option"
          @click="selectFilter(filter.id)"
          :aria-selected="
            activeFilters.indexOf(filter.id) !== -1 ? 'true' : 'false'
          "
          :class="{ active: activeFilters.indexOf(filter.id) !== -1 }"
          class="btn btn-filter"
        >
          {{ filter.name }}
        </button>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "categories-filters",
  data() {
    const VM = this;
    return {
      activeFilters: []
    };
  },
  props: {
    taxonomy: {
      type: String,
      default: "category"
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(["getTaxonomy", "isPageLoaded"]),
    filters() {
      const tax = this.taxonomy.toLowerCase();
      let filters = null;
      if (tax === "posttypes") {
        filters = [];
        const PostTypes = window.WPVUE.post_types;
        Object.keys(PostTypes).forEach(function(item) {
          if (item !== "attachment")
            filters.push({
              name: PostTypes[item].labels.name,
              id: item
            });
        });
      } else {
        filters = this.getTaxonomy(this.taxonomy);
      }
      return filters;
    }
  },
  mounted() {
    if (this.isPageLoaded) {
      this.mountedActions();
    }
  },
  watch: {
    isPageLoaded(val) {
      if (val) {
        this.mountedActions();
      }
    },
    activeFilters(val) {
      this.$emit("filters", val);
    }
  },
  methods: {
    mountedActions() {
      const VM = this;
      const tax = this.taxonomy.toLowerCase();

      if (VM.$route.query.kategori) {
        // ?kategori= can be a single value or repeated (?kategori=3&kategori=7)
        let query = VM.$route.query.kategori;
        query = Array.isArray(query) ? query : [query];
        if (tax !== "posttypes") {
          query = query.map(Number);
        }
        const taxfilt = this.filters ? this.filters.map(it => it.id) : [];
        let matched = query.filter(id => taxfilt.indexOf(id) !== -1);
        if (!this.multiple && matched.length > 1) {
          matched = [matched[0]];
        }
        if (matched.length) {
          this.activeFilters = matched;
        }
      }
      this.$emit("filters", this.activeFilters);
    },
    nullFilters() {
      this.activeFilters = [];
    },
    selectFilter(filterItemId) {
      const elTest = this.activeFilters.indexOf(filterItemId); // check element in array - retutn -1 if null
      if (!this.multiple) {
        this.nullFilters();
      }
      if (elTest !== -1) {
        this.activeFilters.splice(elTest, 1); // remove if exist
      } else {
        this.activeFilters.push(filterItemId); // edd if not exist
      }
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.categoreis-filters {
  .filter-list {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      display: inline-block;
      margin-right: 20px;
    }
  }
  .btn-filter {
    @include fluid-type($smallResText, $wideResText, 12px, 16px);
    color: $fontColor;
    background: transparent;
    font-weight: 400;
    position: relative;
    display: flex;
    padding: 0;
    align-items: center;
    &:before {
      content: "";
      display: inline-block;
      width: 19px;
      height: 19px;
      border: 2px solid $dark;
      margin-right: 10px;
      position: relative;
      z-index: 5;
    }
    &.active {
      text-shadow: 1px 0px 0px $fontColor;
      &:before {
        background-color: $dark !important;
      }
      &:after {
        position: absolute;
        content: "✓";
        z-index: 10;
        color: #fff;
        left: 4px;
        top: 1px;
        font-size: 20px;
      }
    }
    &:hover,
    &:focus {
      text-shadow: 1px 0px 0px $fontColor;
      &:before {
        background-color: darken($colorGray, 10%);
      }
    }
  }
}
</style>
